import {
    SalesforceIcon,
    HubspotIcon,
    PipeDriveIcon,
    XeroIcon,
    QuickBooksIcon,
    GoogleIcon,
    ApiIcon,
    IFoodIcon,
    CoverManagerIcon,
    VTEXIcon,
    FacebookIcon,
    tiktokIcon,
    XIcon,
    LinkedInIcon,
    SquareIcon,
    RingCentralIcon,
} from 'assets/images/integrations';
import { WhatsAppIcon } from 'assets/images/channels';
import zapier from 'assets/images/integrations/zapier.png';
import { AccIntegrationName } from '@constants/integrations';

const SVG_ICONS = {
    [AccIntegrationName['API integration']]: ApiIcon,
    [AccIntegrationName.Google]: GoogleIcon,
    [AccIntegrationName.Salesforce]: SalesforceIcon,
    [AccIntegrationName.Xero]: XeroIcon,
    [AccIntegrationName.Pipedrive]: PipeDriveIcon,
    [AccIntegrationName.Hubspot]: HubspotIcon,
    [AccIntegrationName.QuickBooks]: QuickBooksIcon,
    [AccIntegrationName.iFood]: IFoodIcon,
    [AccIntegrationName.VTEX]: VTEXIcon,
    [AccIntegrationName.CoverManager]: CoverManagerIcon,
    [AccIntegrationName.Facebook]: FacebookIcon,
    [AccIntegrationName.WhatsApp]: WhatsAppIcon,
    [AccIntegrationName.X]: XIcon,
    [AccIntegrationName.LinkedIn]: LinkedInIcon,
    [AccIntegrationName.Square]: SquareIcon,
    [AccIntegrationName.RingCentral]: RingCentralIcon,
};

const IMG_ICONS = {
    [AccIntegrationName.Zapier]: zapier,
    [AccIntegrationName.TikTok]: tiktokIcon,
};

export const getIntegrationIcon = (id, size = 20) => {
    const SvgIcon = SVG_ICONS[id];
    if (SvgIcon) return <SvgIcon width={size} height={size} />;

    const src = IMG_ICONS[id];
    if (src) return <img src={src} alt="" width={size} height={size} style={{ objectFit: 'contain' }} />;

    return null;
};
